(ns ui.components.layout.grid
  (:require
   [ui.util :as uu]))

(defn view-2x2
  [{:keys [class
           style
           grid-cols-class
           grid-rows-class
           height-class
           max-height-class
           top-left-class
           top-right-class
           bottom-left-class
           bottom-right-class
           top-left-scroll-class
           top-right-scroll-class
           top-left-style
           top-right-style
           bottom-left-style
           bottom-right-style]
    :or {grid-cols-class "grid-cols-[320px_minmax(0,1fr)]"
         grid-rows-class "grid-rows-[minmax(0,1fr)_auto]"
         height-class "h-[min(80vh,560px)]"
         max-height-class "max-h-[80vh]"}}
   top-left
   top-right
   bottom-left
   bottom-right]
  [:div
   {:class (uu/cm "grid overflow-hidden"
                  grid-cols-class
                  grid-rows-class
                  height-class
                  max-height-class
                  class)
    :style (merge {:columnGap "0px"
                   :rowGap "0px"}
                  style)}
   [:div
    {:class (uu/cm "min-h-0"
                   top-left-class)
     :style top-left-style}
    [:div
     {:class (uu/cm "h-full overflow-y-auto"
                    top-left-scroll-class)}
     top-left]]
   [:div
    {:class (uu/cm "min-h-0"
                   top-right-class)
     :style top-right-style}
    [:div
     {:class (uu/cm "h-full overflow-y-auto"
                    top-right-scroll-class)}
     top-right]]
   [:div
    {:class (uu/cm "min-h-0"
                   bottom-left-class)
     :style bottom-left-style}
    bottom-left]
   [:div
    {:class (uu/cm "min-h-0"
                   bottom-right-class)
     :style bottom-right-style}
    bottom-right]])
